<script setup lang="ts">
import { computed } from 'vue';
import { formatDate } from '@/plugins/i18n';
import type { SummaryFormCommentDto, SummaryFormOpenVoteDto } from '@/services/types/api.types';

// PROPS
const props = defineProps<{
  text: string;
  userResponse: SummaryFormCommentDto | SummaryFormOpenVoteDto;
}>();

// COMPUTED
const hasName = computed(() => props.userResponse.first_name && props.userResponse.last_name);
</script>
<template>
  <div class="base-comment">
    <div class="base-comment__content">
      {{ props.text }}
    </div>
    <div class="base-comment__details">
      <div class="base-comment__details-user">
        <span class="author" v-if="hasName"
          >{{ props.userResponse.first_name }} {{ props.userResponse.last_name }},</span
        >
        <span class="date">{{ formatDate(props.userResponse.updated_at) }}</span>
      </div>
      <div
        class="base-comment__details-likes"
        v-if="'number_of_likes' in props.userResponse && props.userResponse.number_of_likes"
      >
        <q-icon name="favorite_border" />
        <span>({{ props.userResponse.number_of_likes }})</span>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.base-comment {
  display: flex;
  flex-direction: column;
  font-size: $small-text;
  gap: 12px;
  color: $color-neutral-grey-400;
  margin: $space-sm;

  &__details {
    display: flex;
    flex-direction: row;
    gap: $space-xl;

    &-user {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: $space-sm;

      .author,
      .date {
        font-style: italic;
      }
    }

    &-likes {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: $space-xs;
      font-style: italic;

      .q-icon {
        color: $color-neutral-black;
        font-size: $small-title;
      }
    }
  }
}
</style>
